import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import dayjs from "dayjs";

const STATUS_CHIP = {
  DRAFT: { label: "แบบร่าง", cls: "!text-[#6D788D] !bg-[#EDEFF1]" },
  PENDING_APPROVAL: {
    label: "รออนุมัติ",
    cls: "!text-[#FDB428] !bg-[#FFF6E5]",
  },
  AWAITING_PAYMENT: {
    label: "รอรับชำระ",
    cls: "!text-[#8E94FF] !bg-[#ECEDFF]",
  },
  PAID: { label: "ชำระแล้ว", cls: "!text-[#72E128] !bg-[#EEFBE5]" },
  CANCELED: { label: "ยกเลิก", cls: "!text-[#FF0000] !bg-[#ff000030]" },
};

export default function InfomationForm({
  values,
  setFieldValue,
  handleChange,
  errors,
  formdisabled,
  memberData,
  onTaxInvoiceChange,
  status,
  isNew,
}) {
  const fullName = memberData
    ? `${memberData.first_name_th || ""} ${memberData.last_name_th || ""}`.trim() ||
      memberData.code ||
      "-"
    : "-";

  const address = memberData?.address || "-";
  const phone = memberData?.phone_number || "-";
  const taxNo = memberData?.tax_number || "-";

  return (
    <div className="mb-3 mt-0 shadow bg-white rounded-xl md:p-6 p-4 overflow-hidden">
      <div className="grid grid-cols-9 gap-4">
        {/* Document number */}
        <div className="col-span-2">
          <TextField
            label="เลขที่เอกสาร"
            variant="outlined"
            name="document_no"
            value={values.document_no || ""}
            disabled
            fullWidth
          />
        </div>

        {/* Issue date */}
        <div className="col-span-2">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="วันที่ออกเอกสาร"
              format="DD/MM/YYYY"
              value={values.issue_date ? dayjs(values.issue_date) : null}
              onChange={(v) =>
                setFieldValue("issue_date", v ? v.format('YYYY-MM-DD') : null)
              }
              disabled={formdisabled}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: !!errors.issue_date,
                  helperText: errors.issue_date || "",
                },
              }}
            />
          </LocalizationProvider>
        </div>

        {/* Due date */}
        <div className="col-span-2">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="วันที่ครบกำหนด"
              format="DD/MM/YYYY"
              value={values.due_date ? dayjs(values.due_date) : null}
              onChange={(v) => setFieldValue("due_date", v ? v.format('YYYY-MM-DD') : null)}
              disabled={formdisabled}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: !!errors.due_date,
                  helperText: errors.due_date || "",
                },
              }}
            />
          </LocalizationProvider>
        </div>

        {/* Reference */}
        <div className="col-span-2">
          <TextField
            label="อ้างอิง"
            variant="outlined"
            name="reference"
            value={values.reference || ""}
            error={!!errors.reference}
            onChange={handleChange}
            disabled={formdisabled}
            fullWidth
          />
        </div>

        {/* Status chip */}
        <div className="col-span-1 flex items-center justify-center">
          {!isNew &&
            status &&
            (() => {
              const chip = STATUS_CHIP[status] ?? { label: status, cls: "" };
              return <Chip label={chip.label} className={chip.cls} />;
            })()}
        </div>

        {/* Member info */}
        <div className="col-span-2">
          <div className="text-[#242F48] font-medium mb-2">ชื่อลูกค้า</div>
          <div className="text-[#4C4E64DE] text-sm">{fullName}</div>
        </div>
        <div className="col-span-2">
          <div className="text-[#242F48] font-medium mb-2">ที่อยู่</div>
          <div className="text-[#4C4E64DE] text-sm">{address}</div>
        </div>
        <div className="col-span-2">
          <div className="text-[#242F48] font-medium mb-2">เบอร์โทรศัพท์</div>
          <div className="text-[#4C4E64DE] text-sm">{phone}</div>
        </div>
        <div className="col-span-2">
          <div className="text-[#242F48] font-medium mb-2">
            เลขที่ประจำตัวผู้เสียภาษี
          </div>
          <div className="text-[#4C4E64DE] text-sm">{taxNo}</div>
        </div>
      </div>
      {/* Tax invoice switch */}
      <div className="mt-4">
        <FormControlLabel
          control={
            <Switch
              checked={!!values.is_tax_invoice}
              onChange={(e) => {
                if (onTaxInvoiceChange) {
                  onTaxInvoiceChange(e.target.checked);
                } else {
                  setFieldValue("is_tax_invoice", e.target.checked);
                }
              }}
              disabled={formdisabled}
            />
          }
          label="ออกใบกำกับภาษี"
        />
      </div>
    </div>
  );
}
